<p class='text-muted'>
  Retreva<span style='font-size: 9px; vertical-align: super'>®</span>
  automatically removes all contacts that are in "Remove" status. You cannot
  send a one-time message to these contacts. However, you can send a message to
  contacts that are in other status'. Would you like to include:
</p>
<app-table
  (rowSelected)='onSelection($event)'
  [columns]='tableColumns'
  [dataSourceParams]='dataSourceParams'
  [dataSource]='dataSource'
  [preselectedIdentifier]="'status'"
  [preselected]='preselected'
  [selectable]='true'></app-table>
